export const SET_WINDOW_DIMENSIONS = 'window-resize/SET_WINDOW_DIMENSIONS';

export const SCREEN_SIZE_CATEGORIES = {
  screen_xxs: 320,
  screen_sm: 576,
  screen_md: 768,
  screen_lg: 992,
  screen_xl: 1200,
  screen_xxl: 1600,
};

const initialState = {
  isTablet: false,
  isMobile: false,
  screenIsLandscape: false,
  windowWidth: 0,
  windowHeight: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
  // eslint-disable-next-line no-case-declarations
  case SET_WINDOW_DIMENSIONS:
    const { width, height, orientation } = action.payload;

    return {
      isTablet:
        width < SCREEN_SIZE_CATEGORIES.screen_lg &&
        width >= SCREEN_SIZE_CATEGORIES.screen_sm,
      isMobile: width < SCREEN_SIZE_CATEGORIES.screen_sm,
      screenIsLandscape: width > height && orientation !== 0,
      windowWidth: width,
      windowHeight: height,
    };
  default:
    return state;
  }
};

export const setWindowDimensionsAction = payload => ({
  type: SET_WINDOW_DIMENSIONS,
  payload,
});



// WEBPACK FOOTER //
// ./src/client/redux/window-resize.js